import { createIcon } from "@chakra-ui/react";

export const IconSidebarRight = createIcon({
  displayName: "IconSidebarRight",
  viewBox: "0 0 24 24",
  defaultProps: {
    h: 6,
    w: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentcolor",
    strokeWidth: "2",
  },
  path: [
    <path key={1} d="M21 5V19" fill="none" />,
    <path key={2} d="M10 17L15 12L10 7" fill="none" />,
    <path key={3} d="M15 12H3" fill="none" />,
  ],
});
